import { Resolver } from "@/api/router/resolver";
import { notificationsService } from "@/services/NotificationsService";

export class NotificationsResolver extends Resolver<any> {
  public resolve(): Promise<any> {
    return notificationsService.getPageData();
  }
}
